import { Component } from '@angular/core';
import { commonurls } from '../../commonBaseUrls';

@Component({
  selector: 'app-refund-policy',
  templateUrl: './refund-policy.component.html',
  styleUrl: './refund-policy.component.scss'
})
export class RefundPolicyComponent {

  public websiteUrl = commonurls?.websiteUrl;
  public refundMail = commonurls?.refundMail;
  public refundInMail = commonurls?.refundInMail;
  public liveUrl = commonurls?.liveUrl;
}
